var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMediumMobile = function SvgIconMediumMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M10.625 10c0 2.93-2.242 5.313-5 5.313s-5-2.383-5-5.313 2.242-5.312 5-5.312 5 2.382 5 5.312m8.125-5a.625.625 0 0 0-.625.625s-.312 1.04-.312 4.375.312 4.375.312 4.375a.624.624 0 1 0 1.25 0s.313-1.04.313-4.375-.313-4.375-.313-4.375A.625.625 0 0 0 18.75 5m-4.375 0c-.445 0-1.281.219-1.898 1.664-.391.899-.602 2.086-.602 3.336s.21 2.438.602 3.336C13.094 14.78 13.93 15 14.375 15s1.281-.219 1.898-1.664c.391-.899.602-2.086.602-3.336s-.21-2.437-.602-3.336C15.656 5.22 14.82 5 14.375 5"
  })));
};
export default SvgIconMediumMobile;